var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 254,
    viewBox: "0 0 254 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9004 225.461L80.9555 176.181H173.576L194.14 225.461H63.9004Z",
    fill: "#D4D5F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.262 193.78C170.031 193.78 204.702 159.109 204.702 116.34C204.702 73.5715 170.031 38.9004 127.262 38.9004C84.4934 38.9004 49.8223 73.5715 49.8223 116.34C49.8223 159.109 84.4934 193.78 127.262 193.78Z",
    fill: "#2E2E2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.663 24.8223H176.543V45.9423H197.663V24.8223Z",
    fill: "#D4D5F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M225.819 52.9814H204.699V74.1015H225.819V52.9814Z",
    fill: "#D4D5F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M169.501 70.5811H148.381V91.7011H169.501V70.5811Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.339 98.7422H120.219V119.862H141.339V98.7422Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBet);
export default __webpack_public_path__ + "static/media/bet.7dd581deb9cb26716d2f34c54b3b4900.svg";
export { ForwardRef as ReactComponent };